import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./styles/main.scss"; // Bootstrap wird hier einmalig geladen
import reportWebVitals from './reportWebVitals';

import "./i18n"; // Importiere die i18n-Konfiguration

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
